module.exports = __webpack_public_path__ + "static/img/bubble-triangle.50801640.png";